import { Observable } from 'rxjs';
import { BaseCardConfiguration } from 'app/core/components/workflow-new/common/base-card-configuration';

export class MaterialConfiguration extends BaseCardConfiguration {
    subtitle: string;
}




// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/material-configuration.ts